<template>
    <div  class="alert-ringraziamento-container text-start">
        <div class="alert alert-success" role="alert">
            <div style="margin-bottom: 10px;" v-html="messaggioRingraziamento"></div>
        </div>
    </div>
</template>

<script>
import intl from "./intl/intl";

export default {
    name: "alertRingraziamento",
    mounted() {},
    props: {
        email: {
            type: String,
            default: '',
        },
        
    },
    

    data: function () {
        return {
            intl: intl,
            
            
        };
    },
    methods: {
        
    },
    watch: {
        
        
    },
    computed: {
        messaggioRingraziamento:function(){

            return this.intl[this.$store.state.lang]['html_ringraziamento'].replace("**mail**", this.email);
        },
    },
};
</script>
